import {toQueryString} from '@s-ui/js/lib/string'

// Foreign context imports
import DealerEntitiesFactory from '../../dealer/Entities/factory.js'
import {LocationValueObjectsFactory} from '../../location/ValueObjects/factory.js'
// Seller factories imports
import {SellerErrorsFactory} from '../Errors/factory.js'
import {SellerRequestsFactory} from '../Requests/factory.js'
import {SellerValueObjectsFactory} from '../ValueObjects/factory.js'
// Mappers
import {CloseDealersResponseToValueObjectSellerMapper} from './CloseDealersResponseToValueObjectSellerMapper.js'
import FromSellerErrorsToContactValidationSellerErrors from './FromSellerErrorsToContactValidationSellerErrors.js'
import {GetSellerRequestMapper} from './GetSellerRequestMapper.js'
import {MakeLeadResponseToContactModelSellerResponseVO} from './MakeLeadResponseToContactModelSellerResponseVO.js'
import {RawParamsToGetInstantOfferRequestSellerMapper} from './RawParamsToGetInstantOfferRequestSellerMapper.js'
import {RawParamsToGetRecommendedPriceRequestSellerMapper} from './RawParamsToGetRecommendedPriceRequestSellerMapper.js'
import {RawParamsToGetSimulatedInstantOfferRequestSellerMapper} from './RawParamsToGetSimulatedInstantOfferRequestSellerMapper.js'

export class SellerMappersFactory {
  static closeDealersResponseToValueObjectSellerMapper = ({config}) =>
    new CloseDealersResponseToValueObjectSellerMapper({
      config,
      closeDealerScheduleListVOFactory: SellerValueObjectsFactory.closeDealerScheduleListSellerValueObject,
      closeDealerScheduleVOFactory: SellerValueObjectsFactory.closeDealerScheduleSellerValueObject,
      dealerEntityFactory: DealerEntitiesFactory.dealerEntity,
      locationVOFactory: LocationValueObjectsFactory.locationValueObject
    })

  static makeLeadResponseToContactModelSellerResponseVOMapper = () =>
    new MakeLeadResponseToContactModelSellerResponseVO({
      contactModelSellerResponseValueObject: SellerValueObjectsFactory.contactModelSellerResponseValueObject
    })

  static fromSellerErrorsToContactValidationSellerErrors = ({config}) =>
    new FromSellerErrorsToContactValidationSellerErrors({config})

  static getSellerRequestMapper = ({config}) =>
    new GetSellerRequestMapper({
      config,
      getSellerRequestFactory: SellerRequestsFactory.getSellerRequest
    })

  static rawParamsToGetSimulatedInstantOfferRequestSellerMapper = ({config}) =>
    new RawParamsToGetSimulatedInstantOfferRequestSellerMapper({
      config,
      getSimulatedInstantOfferRequestFactory: SellerRequestsFactory.getSimulatedInstantOfferSellerRequest
    })

  static rawParamsToGetInstantOfferRequestSellerMapper = ({config}) =>
    new RawParamsToGetInstantOfferRequestSellerMapper({
      config,
      getInstantOfferRequestFactory: SellerRequestsFactory.getInstantOfferSellerRequest
    })

  static rawParamsToGetRecommendedPriceRequestSellerMapper = () =>
    new RawParamsToGetRecommendedPriceRequestSellerMapper({
      getRecommendedPriceRequestFactory: SellerRequestsFactory.getRecommendedPriceSellerRequest,
      invalidRequestSellerErrorFactory: SellerErrorsFactory.invalidRequestSellerError,
      toQueryString
    })
}
